import { OptionKey } from '@common-fe/common-fe';

import {
  ReportSummaryRequestBaseParams,
  ReportTableRequestBaseParams,
} from '../ReportSummary/ReportSummary.types';
export enum ForfeitureSide {
  ByEmployer = 'EMPLOYEE',
  ByTransaction = 'TRANSACTION',
}

export interface ForfeitureSummaryReportParams extends ReportSummaryRequestBaseParams {
  planYearPeriod: OptionKey[];
}
export interface ForfeitureReportTableParams extends ReportTableRequestBaseParams {
  isSSNShowed: boolean;
  planYearPeriod: OptionKey[];
  forfeitureGroup: ForfeitureSide;
}
